exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";table th a{display:block;position:relative;color:#5f6a70;text-decoration:underline}table th a.ordered-asc,table th a.ordered-asc:after,table th a.ordered-desc,table th a.ordered-desc:before{color:#75100c}table th a:before{content:\"\\25BC\";position:absolute;right:0;color:#5f6a70}table th a:after{content:\"\\25B2\";position:absolute;right:12px;color:#5f6a70}", ""]);

// exports
